import { render } from "./smsModal.vue?vue&type=template&id=661cc2fc&scoped=true"
import script from "./smsModal.vue?vue&type=script&lang=js"
export * from "./smsModal.vue?vue&type=script&lang=js"

import "./smsModal.vue?vue&type=style&index=0&id=661cc2fc&lang=less&scoped=true"
script.render = render
script.__scopeId = "data-v-661cc2fc"

export default script